let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1NJ6g")).then(() => parcelRequire('jxCl2'));